// -------- Gallery shuffle --------
  (function () {
    document.querySelectorAll('[data-gallery-shuffle]').forEach(grid => {
      const items = Array.from(grid.children);
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        grid.appendChild(items[j]);
        items.splice(j, 1);
      }
    });
  })();

  // -------- Scroll reveal --------
  (function () {
    const els = document.querySelectorAll('.reveal, .reveal-display, .reveal-line');
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(el => io.observe(el));
  })();

  // -------- Header scroll state --------
  (function () {
    const header = document.querySelector('.site-header');
    if (!header) return;
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  // -------- Mobile menu toggle --------
  (function () {
    const toggle = document.querySelector('.menu-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const isOpen = document.body.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });
    // Close when nav link clicked
    document.querySelectorAll('[data-header-nav] a').forEach(a => {
      a.addEventListener('click', () => {
        document.body.classList.remove('menu-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  })();

  // -------- Hero video: desktop-only load + autoplay --------
  // The video is display:none under 900px, so never download it there.
  (function () {
    const video = document.querySelector('.hero-video');
    if (!video) return;
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const tryPlay = () => {
      const p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => {
          // Autoplay was blocked — start on first user gesture
          const startOnGesture = () => {
            video.play().catch(() => {});
            ['touchstart', 'click', 'scroll'].forEach(ev =>
              window.removeEventListener(ev, startOnGesture)
            );
          };
          ['touchstart', 'click', 'scroll'].forEach(ev =>
            window.addEventListener(ev, startOnGesture, { once: true, passive: true })
          );
        });
      }
    };

    const load = () => {
      if (!video.getAttribute('src')) {
        const src = video.dataset.src;
        if (!src) return;
        video.src = src;
      }
      if (video.readyState >= 2) tryPlay();
      else video.addEventListener('loadeddata', tryPlay, { once: true });
    };

    const mq = window.matchMedia('(min-width: 901px)');
    if (mq.matches) {
      load();
    } else {
      const onChange = (e) => {
        if (!e.matches) return;
        mq.removeEventListener('change', onChange);
        load();
      };
      mq.addEventListener('change', onChange);
    }
  })();

  // -------- Announcement bar rotator --------
  (function () {
    const msgs = document.querySelectorAll('.announcement-msg');
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 3000);
  })();

  // -------- Featured product gallery thumbnails --------
  (function () {
    const labels = [
      'finished model — 3/4 hero, soft window light',
      'profile shot, low angle on walnut surface',
      'detail — engraved base and badge',
      'detail — painted finish, brake calipers',
      'in-context — on a study desk'
    ];
    const main = document.getElementById('featured-main');
    const mainLabel = document.getElementById('featured-main-label');
    const dots = document.querySelectorAll('.gallery-dots button');
    const thumbs = document.querySelectorAll('.gallery-thumbs .img-ph');
    function set(i) {
      dots.forEach(d => d.classList.toggle('is-active', Number(d.dataset.i) === i));
      thumbs.forEach(t => t.classList.toggle('is-active', Number(t.dataset.i) === i));
      if (mainLabel) mainLabel.textContent = labels[i] || labels[0];
    }
    dots.forEach(d => d.addEventListener('click', () => set(Number(d.dataset.i))));
    thumbs.forEach(t => t.addEventListener('click', () => set(Number(t.dataset.i))));
  })();

  // -------- GSAP-driven motion suite --------
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const isFinePointer = window.matchMedia('(pointer: fine)').matches;

    let tries = 0;
    const start = () => {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        if (tries++ < 50) return setTimeout(start, 80);
        return; // GSAP unavailable — static content stays visible, just without motion
      }
      gsap.registerPlugin(ScrollTrigger);

      // ---- Hero entrance choreography ----
      const heroText = document.querySelector('[data-hero-text]');
      const heroImage = document.querySelector('[data-hero-image]');
      if (heroText) {
        const eyebrow = heroText.querySelector('[data-hero-eyebrow]');
        const headline = heroText.querySelector('[data-hero-headline]');
        const sub = heroText.querySelector('[data-hero-sub]');
        const cta = heroText.querySelector('[data-hero-cta]');

        // Split headline into words
        if (headline) {
          const text = headline.textContent.trim();
          headline.innerHTML = text.split(/(\s+)/).map(part =>
            /^\s+$/.test(part) ? part : `<span class="hero-word">${part}</span>`
          ).join('');
        }

        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
        if (eyebrow) tl.from(eyebrow, { opacity: 0, y: 12, duration: 0.7 }, 0);
        if (headline) tl.from(headline.querySelectorAll('.hero-word'), {
          opacity: 0, y: 36, filter: 'blur(8px)', duration: 1.1, stagger: 0.08
        }, 0.15);
        if (sub) tl.from(sub, { opacity: 0, y: 16, duration: 0.9 }, 0.7);
        if (cta) tl.from(cta, { opacity: 0, y: 14, duration: 0.7 }, 0.85);
        if (heroImage) tl.from(heroImage, {
          opacity: 0, scale: 1.08, duration: 1.4, ease: 'power2.out'
        }, 0.05);
      }

      // ---- Scroll-scrub parallax on hero image ----
      if (heroImage) {
        gsap.to(heroImage, {
          yPercent: -8,
          ease: 'none',
          scrollTrigger: {
            trigger: heroImage,
            start: 'top top',
            end: 'bottom top',
            scrub: 0.5
          }
        });
      }

      // ---- 3D tilt on data-tilt elements ----
      if (isFinePointer) {
        document.querySelectorAll('[data-tilt]').forEach(el => {
          const max = 10; // degrees
          const setRX = gsap.quickTo(el, 'rotationX', { duration: 0.5, ease: 'power3.out' });
          const setRY = gsap.quickTo(el, 'rotationY', { duration: 0.5, ease: 'power3.out' });
          const setS = gsap.quickTo(el, 'scale', { duration: 0.5, ease: 'power3.out' });
          gsap.set(el, { transformPerspective: 900, transformStyle: 'preserve-3d', willChange: 'transform' });

          el.addEventListener('mousemove', (e) => {
            const r = el.getBoundingClientRect();
            const x = (e.clientX - r.left) / r.width - 0.5;
            const y = (e.clientY - r.top) / r.height - 0.5;
            setRX(-y * max);
            setRY(x * max);
            setS(1.03);
          });
          el.addEventListener('mouseleave', () => {
            setRX(0); setRY(0); setS(1);
          });
        });
      }

      // ---- Magnetic buttons ----
      if (isFinePointer) {
        document.querySelectorAll('[data-magnetic]').forEach(el => {
          const range = 90; // px from center where magnetism kicks in
          const strength = 0.35;
          const setX = gsap.quickTo(el, 'x', { duration: 0.5, ease: 'power3.out' });
          const setY = gsap.quickTo(el, 'y', { duration: 0.5, ease: 'power3.out' });
          gsap.set(el, { willChange: 'transform' });

          const onMove = (e) => {
            const r = el.getBoundingClientRect();
            const cx = r.left + r.width / 2;
            const cy = r.top + r.height / 2;
            const dx = e.clientX - cx;
            const dy = e.clientY - cy;
            const dist = Math.hypot(dx, dy);
            if (dist < range + Math.max(r.width, r.height) / 2) {
              setX(dx * strength);
              setY(dy * strength);
            } else {
              setX(0); setY(0);
            }
          };
          window.addEventListener('mousemove', onMove, { passive: true });
          el.addEventListener('mouseleave', () => { setX(0); setY(0); });
        });
      }
    };
    start();
  })();

  // -------- GSAP word reveal --------
  (function () {
    const targets = document.querySelectorAll('[data-gsap-words]');
    if (!targets.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Wait for GSAP to load (deferred scripts)
    let tries = 0;
    const start = () => {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        if (tries++ < 50) return setTimeout(start, 80);
        return; // GSAP unavailable — text renders un-split at full opacity
      }
      gsap.registerPlugin(ScrollTrigger);

      targets.forEach(container => {
        // Walk text nodes only — preserves <em>, <strong>, etc.
        const walk = (node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const frag = document.createDocumentFragment();
            const parts = node.textContent.split(/(\s+)/);
            parts.forEach(part => {
              if (/^\s+$/.test(part)) {
                frag.appendChild(document.createTextNode(part));
              } else if (part.length) {
                const span = document.createElement('span');
                span.className = 'word';
                span.textContent = part;
                frag.appendChild(span);
              }
            });
            node.parentNode.replaceChild(frag, node);
          } else if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length) {
            Array.from(node.childNodes).forEach(walk);
          }
        };
        walk(container);

        const words = container.querySelectorAll('.word');
        gsap.to(words, {
          opacity: 1,
          stagger: 0.04,
          ease: 'none',
          scrollTrigger: {
            trigger: container,
            start: 'top 80%',
            end: 'bottom 55%',
            scrub: 0.6
          }
        });
      });
    };
    start();
  })();

  // -------- Photo previews + submit-time compression --------
  window.__relixCompressImage = function (file) {
    const MAX_EDGE = 1800;
    const QUALITY = 0.85;
    return new Promise((resolve) => {
      if (!file || !file.type || !file.type.startsWith('image/')) return resolve(file);
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(url);
        let { width, height } = img;
        if (width > MAX_EDGE || height > MAX_EDGE) {
          if (width > height) {
            height = Math.round(height * (MAX_EDGE / width));
            width = MAX_EDGE;
          } else {
            width = Math.round(width * (MAX_EDGE / height));
            height = MAX_EDGE;
          }
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        canvas.toBlob(blob => {
          if (!blob) return resolve(file);
          const newName = (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
          resolve(new File([blob], newName, { type: 'image/jpeg', lastModified: Date.now() }));
        }, 'image/jpeg', QUALITY);
      };
      img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
      img.src = url;
    });
  };

  // Background compression cache — keyed by input element
  const __compressedCache = new WeakMap(); // input -> Promise<File>

  // Photo preview + kick off compression in background
  (function () {
    document.querySelectorAll('[data-photo-slot]').forEach(slot => {
      const input = slot.querySelector('[data-photo-input]');
      const preview = slot.querySelector('.photo-slot-preview');
      const clearBtn = slot.querySelector('[data-photo-clear]');
      if (!input || !preview || !clearBtn) return;

      input.addEventListener('change', () => {
        const file = input.files && input.files[0];
        if (!file) {
          __compressedCache.delete(input);
          return;
        }
        // Show preview immediately
        const reader = new FileReader();
        reader.onload = e => {
          // The file may have been cleared while this read was in flight
          // (e.g. switching License plate back to "Remove") — don't resurrect it.
          if (!input.files || input.files[0] !== file) return;
          preview.src = e.target.result;
          preview.hidden = false;
          clearBtn.hidden = false;
          slot.classList.add('has-file');
        };
        reader.readAsDataURL(file);
        // Start compression in the background so it's ready by the time user clicks submit
        __compressedCache.set(input, window.__relixCompressImage(file));
      });

      clearBtn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        input.value = '';
        preview.removeAttribute('src');
        preview.hidden = true;
        clearBtn.hidden = true;
        slot.classList.remove('has-file');
        __compressedCache.delete(input);
      });
    });
  })();

  // Submit handler for buy form — uses pre-compressed cache, falls back to live compress
  (function () {
    const form = document.querySelector('[data-buy-form]');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      const fileInputs = Array.from(form.querySelectorAll('input[type="file"]'));
      const hasFiles = fileInputs.some(inp => inp.files && inp.files[0]);
      if (!hasFiles) return; // No files, let it submit normally

      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      const origLabel = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding to cart…';
      }

      try {
        const compressed = await Promise.all(
          fileInputs.map(async (inp) => {
            const f = inp.files && inp.files[0];
            if (!f) return null;
            // Prefer cached compressed result; fall back to live compress
            const cached = __compressedCache.get(inp);
            const file = cached ? await cached : await window.__relixCompressImage(f);
            return { name: inp.name, file };
          })
        );

        const fd = new FormData(form);
        compressed.filter(Boolean).forEach(({ name, file }) => fd.set(name, file));

        const response = await fetch(form.action, {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json, text/html' }
        });

        if (response.redirected) { window.location.href = response.url; return; }
        if (response.ok) { window.location.href = form.dataset.cartUrl || '/cart'; return; }

        let errMsg = 'Could not add to cart. Please try again.';
        try {
          const data = await response.json();
          if (data && data.description) errMsg = data.description;
          else if (data && data.message) errMsg = data.message;
        } catch (_) {}
        throw new Error(errMsg);
      } catch (err) {
        const msg = err.message || 'Sorry — there was a problem adding your build to cart. Please try again.';
        let errEl = form.querySelector('[data-buy-error]');
        if (!errEl) {
          errEl = document.createElement('div');
          errEl.className = 'buy-error';
          errEl.setAttribute('data-buy-error', '');
          errEl.setAttribute('role', 'alert');
          if (submitBtn && submitBtn.parentNode) submitBtn.parentNode.insertBefore(errEl, submitBtn);
          else form.appendChild(errEl);
        }
        errEl.textContent = msg;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = origLabel;
        }
      }
    });
  })();

  // -------- Customer media gallery --------
  (function () {
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      const panels = Array.from(gallery.querySelectorAll('[data-gallery-panel]'));
      const buttons = Array.from(gallery.querySelectorAll('[data-gallery-target]'));
      const controls = gallery.querySelector('[data-gallery-controls]');
      if (!panels.length || !buttons.length) return;
      if (controls) controls.hidden = false;
      const navigation = gallery.querySelector('[data-gallery-navigation]');
      const count = gallery.querySelector('[data-gallery-count]');
      const viewer = gallery.querySelector('[data-gallery-viewer]');
      if (navigation) navigation.hidden = false;

      const select = (button) => {
        const target = panels.find(panel => panel.id === button.dataset.galleryTarget);
        if (!target) return;
        panels.forEach(panel => {
          panel.hidden = panel !== target;
          if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
        });
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        if (count) count.textContent = `${buttons.indexOf(button) + 1} / ${buttons.length}`;
      };
      const move = direction => {
        const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        select(buttons[(current + direction + buttons.length) % buttons.length]);
      };
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => move(-1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => move(1));
      // Horizontal swipes on images; preserve vertical page scrolling and video controls.
      let touchStart = null;
      viewer?.addEventListener('pointerdown', event => {
        touchStart = event.pointerType === 'touch' && !event.target.closest('button, a, video')
          ? { x: event.clientX, y: event.clientY } : null;
      });
      viewer?.addEventListener('pointerup', event => {
        if (!touchStart) return;
        const dx = event.clientX - touchStart.x;
        const dy = event.clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) move(dx < 0 ? 1 : -1);
      });
      viewer?.addEventListener('pointercancel', () => { touchStart = null; });
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          buttons[next].focus();
          select(buttons[next]);
        });
      });

      const video = gallery.querySelector('[data-customer-video]');
      const play = gallery.querySelector('[data-gallery-play]');
      if (video && play) {
        play.hidden = false;
        play.addEventListener('click', () => {
          play.hidden = true;
          video.play().catch(() => { play.hidden = false; });
        });
        video.addEventListener('play', () => { play.hidden = true; });
        video.addEventListener('ended', () => { play.hidden = false; });
      }
    });
  })();

  // -------- Tap-to-zoom viewer for the example photos --------
  (function () {
    const box = document.querySelector('[data-zoom-lightbox]');
    if (!box) return;
    const img = box.querySelector('[data-zoom-img]');
    const closeBtn = box.querySelector('[data-zoom-close]');
    let lastFocused = null;

    const open = (src, alt) => {
      if (!src) return;
      img.src = src;
      img.alt = alt || '';
      box.hidden = false;
      // Stop the page scrolling behind the overlay on touch devices.
      document.body.classList.add('zoom-open');
      if (closeBtn) closeBtn.focus();
    };

    const close = () => {
      box.hidden = true;
      img.removeAttribute('src');
      document.body.classList.remove('zoom-open');
      if (lastFocused) { try { lastFocused.focus(); } catch (e) {} }
    };

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-zoom]');
      if (trigger) {
        e.preventDefault();
        lastFocused = trigger;
        open(trigger.dataset.zoomSrc, trigger.dataset.zoomAlt);
        return;
      }
      // Backdrop or the close button dismisses; taps on the image itself do not.
      if (!box.hidden && (e.target === box || e.target.closest('[data-zoom-close]'))) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  })();

  // -------- Buy form: price update + variant picker --------
  (function () {
    const form = document.querySelector('[data-buy-form]');
    if (!form) return;

    // Subject + size + price wiring
    const idInput = form.querySelector('[data-id-input]');
    const priceEls = Array.from(form.querySelectorAll('[data-price-display]'));
    const compareEls = Array.from(form.querySelectorAll('[data-price-compare]'));
    const saveEls = Array.from(form.querySelectorAll('[data-price-save]'));
    // `compare` / `save` are undefined for variants that are not on sale, which
    // hides both elements rather than leaving a stale price struck through.
    const showPrice = (value, compare, save) => {
      priceEls.forEach(el => { el.textContent = value; });
      compareEls.forEach(el => { el.textContent = compare || ''; el.hidden = !compare; });
      saveEls.forEach(el => { el.textContent = save ? ('Save ' + save) : ''; el.hidden = !save; });
    };

    // ---- Multi-option product page (one picker per Shopify product option) ----
    const variantsScript = form.querySelector('[data-variants-json]');
    if (variantsScript && idInput) {
      let variants = [];
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}
      const pickers = Array.from(form.querySelectorAll('[data-option-picker]'));

      const currentSelection = () => pickers.map(p => {
        const checked = p.querySelector('[data-option-value]:checked');
        return checked ? checked.value : null;
      });

      const findVariant = (sel) => variants.find(v =>
        v.options.length === sel.length && v.options.every((o, i) => o === sel[i])
      );

      const updateAvailability = () => {
        const sel = currentSelection();
        pickers.forEach((picker, pi) => {
          picker.querySelectorAll('[data-option-value]').forEach(input => {
            const trial = sel.slice();
            trial[pi] = input.value;
            const match = findVariant(trial);
            const label = input.closest('.size-radio');
            const optionPrice = label.querySelector('[data-option-price]');
            if (optionPrice) optionPrice.textContent = match && match.available ? (match.priceShort || match.price) : 'Unavailable';
            const optionCompare = label.querySelector('[data-option-compare]');
            if (optionCompare) {
              const showCompare = !!(match && match.available && match.compareAtShort);
              optionCompare.textContent = showCompare ? match.compareAtShort : '';
              optionCompare.hidden = !showCompare;
            }
            if (!match || !match.available) {
              label.classList.add('is-unavailable');
              input.disabled = true;
            } else {
              label.classList.remove('is-unavailable');
              input.disabled = false;
            }
          });
        });
      };

      // ---- License plate photo: only ask for it when "Keep" is chosen ----
      const plateBlock = form.querySelector('[data-plate-block]');
      const platePicker = pickers.find(p => (p.dataset.optionName || '') === 'License plate');
      const syncPlate = () => {
        if (!plateBlock || !platePicker) return;
        const checked = platePicker.querySelector('[data-option-value]:checked');
        const keep = !!checked && checked.value === 'Keep';
        plateBlock.hidden = !keep;
        const input = plateBlock.querySelector('[data-plate-input]');
        if (!input) return;
        // A hidden required input blocks form submission — keep them in lockstep.
        input.required = keep;
        // Disabled controls are excluded from FormData and from constraint
        // validation entirely, so a hidden plate slot can never contribute an
        // empty file part to the cart request.
        input.disabled = !keep;
        // Dropping back to "Remove" must discard any staged plate photo so it
        // isn't sent as a line item property. Reuse the slot's own clear button
        // so the preview, cached compression and styling all reset together.
        if (!keep && input.files && input.files.length) {
          const clearBtn = plateBlock.querySelector('[data-photo-clear]');
          if (clearBtn) clearBtn.click();
        }
      };

      const sync = () => {
        const sel = currentSelection();
        const v = findVariant(sel);
        if (v) {
          idInput.value = v.id;
          showPrice(v.price, v.compareAt, v.save);
        }
        const submit = form.querySelector('button[type="submit"]');
        if (submit) submit.disabled = !v || !v.available;
        updateAvailability();
        syncPlate();
      };

      pickers.forEach(picker => {
        picker.addEventListener('change', e => {
          if (e.target.matches('[data-option-value]')) sync();
        });
      });
      sync();
      return;
    }

    // ---- Subject groups (homepage multi-product form) ----
    function updateFromCurrentSelection() {
      const activeGroup = form.querySelector('.size-picker:not([hidden])');
      if (!activeGroup) return;
      const checked = activeGroup.querySelector('[data-size-radio]:checked')
        || activeGroup.querySelector('[data-size-radio]:not(:disabled)');
      if (!checked) return;
      if (!checked.checked) checked.checked = true;
      if (idInput) idInput.value = checked.dataset.variantId || checked.value;
      if (checked.dataset.price) showPrice(checked.dataset.price);
    }

    form.querySelectorAll('[data-subject-index]').forEach(subjectRadio => {
      subjectRadio.addEventListener('change', () => {
        const idx = subjectRadio.dataset.subjectIndex;
        form.querySelectorAll('.size-picker[data-size-group]').forEach(group => {
          group.hidden = group.dataset.sizeGroup !== idx;
        });
        updateFromCurrentSelection();
      });
    });

    form.querySelectorAll('[data-size-radio]').forEach(sizeRadio => {
      sizeRadio.addEventListener('change', () => {
        if (sizeRadio.checked) updateFromCurrentSelection();
      });
    });

    // ---- Single-product fallback (one set of radios with name="id") ----
    if (!idInput) {
      form.querySelectorAll('input[name="id"]').forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked && radio.dataset.price) {
            showPrice(radio.dataset.price);
          }
        });
      });
    }
  })();

  // -------- FAQ accordion --------
  (function () {
    const items = document.querySelectorAll('.faq-item');
    function close(item) {
      item.classList.remove('is-open');
      const a = item.querySelector('.faq-a');
      a.style.maxHeight = '0px';
      a.setAttribute('inert', '');
      item.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
    }
    function open(item) {
      item.classList.add('is-open');
      const a = item.querySelector('.faq-a');
      a.style.maxHeight = a.scrollHeight + 'px';
      a.removeAttribute('inert');
      item.querySelector('.faq-q').setAttribute('aria-expanded', 'true');
    }
    items.forEach(item => {
      const btn = item.querySelector('.faq-q');
      btn.addEventListener('click', () => {
        if (item.classList.contains('is-open')) close(item);
        else open(item);
      });
      // Initialize open state heights; keep collapsed answers out of the tab order
      const a = item.querySelector('.faq-a');
      if (item.classList.contains('is-open')) {
        a.style.maxHeight = a.scrollHeight + 'px';
      } else {
        a.setAttribute('inert', '');
      }
    });
    window.addEventListener('resize', () => {
      items.forEach(item => {
        if (item.classList.contains('is-open')) {
          const a = item.querySelector('.faq-a');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  })();

  // -------- Meta attribution handoff (_fbp/_fbc → cart attributes) --------
  // The CAPI worker reads these back from the order's note_attributes so
  // server-side Purchases carry browser/click IDs (big match-quality win).
  (function () {
    try { if (sessionStorage.getItem('relix_fb_attr')) return; } catch (e) { return; }

    var readCookie = function (name) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
      return m ? decodeURIComponent(m[1]) : '';
    };

    var send = function () {
      try { if (sessionStorage.getItem('relix_fb_attr')) return; } catch (e) {}
      var fbp = readCookie('_fbp');
      var fbc = readCookie('_fbc');
      if (!fbc) {
        var fbclid = new URLSearchParams(window.location.search).get('fbclid');
        if (fbclid) fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      }
      if (!fbp && !fbc) return;
      var attrs = {};
      if (fbp) attrs._fbp = fbp;
      if (fbc) attrs._fbc = fbc;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () {
        try { sessionStorage.setItem('relix_fb_attr', '1'); } catch (e) {}
      }).catch(function () {});
    };

    // _fbp appears shortly after the Meta pixel boots; try twice.
    setTimeout(send, 3000);
    setTimeout(send, 10000);
  })();

  // -------- Geo banner (currency suggestion) --------
  (function () {
    const STORAGE_KEY = 'relix_geo_dismissed';
    const COUNTRIES = {
      GB: { name: 'United Kingdom', currency: 'GBP' },
      AT: { name: 'Austria', currency: 'EUR' }, BE: { name: 'Belgium', currency: 'EUR' },
      BG: { name: 'Bulgaria', currency: 'BGN' }, HR: { name: 'Croatia', currency: 'EUR' },
      CY: { name: 'Cyprus', currency: 'EUR' }, CZ: { name: 'Czechia', currency: 'CZK' },
      DK: { name: 'Denmark', currency: 'DKK' }, EE: { name: 'Estonia', currency: 'EUR' },
      FI: { name: 'Finland', currency: 'EUR' }, FR: { name: 'France', currency: 'EUR' },
      DE: { name: 'Germany', currency: 'EUR' }, GR: { name: 'Greece', currency: 'EUR' },
      HU: { name: 'Hungary', currency: 'HUF' }, IE: { name: 'Ireland', currency: 'EUR' },
      IT: { name: 'Italy', currency: 'EUR' }, LV: { name: 'Latvia', currency: 'EUR' },
      LT: { name: 'Lithuania', currency: 'EUR' }, LU: { name: 'Luxembourg', currency: 'EUR' },
      MT: { name: 'Malta', currency: 'EUR' }, NL: { name: 'Netherlands', currency: 'EUR' },
      PL: { name: 'Poland', currency: 'PLN' }, PT: { name: 'Portugal', currency: 'EUR' },
      RO: { name: 'Romania', currency: 'RON' }, SK: { name: 'Slovakia', currency: 'EUR' },
      SI: { name: 'Slovenia', currency: 'EUR' }, ES: { name: 'Spain', currency: 'EUR' },
      SE: { name: 'Sweden', currency: 'SEK' }, IS: { name: 'Iceland', currency: 'ISK' },
      NO: { name: 'Norway', currency: 'NOK' }, CH: { name: 'Switzerland', currency: 'CHF' },
      TR: { name: 'Türkiye', currency: 'TRY' },
      AU: { name: 'Australia', currency: 'AUD' }, NZ: { name: 'New Zealand', currency: 'NZD' },
      JP: { name: 'Japan', currency: 'JPY' }, KR: { name: 'South Korea', currency: 'KRW' },
      SG: { name: 'Singapore', currency: 'SGD' }, HK: { name: 'Hong Kong', currency: 'HKD' },
      TW: { name: 'Taiwan', currency: 'TWD' }, MY: { name: 'Malaysia', currency: 'MYR' },
      TH: { name: 'Thailand', currency: 'THB' }, PH: { name: 'Philippines', currency: 'PHP' },
      ID: { name: 'Indonesia', currency: 'IDR' }, VN: { name: 'Vietnam', currency: 'VND' },
      AE: { name: 'United Arab Emirates', currency: 'AED' }, SA: { name: 'Saudi Arabia', currency: 'SAR' },
      KW: { name: 'Kuwait', currency: 'KWD' }, QA: { name: 'Qatar', currency: 'QAR' },
      BH: { name: 'Bahrain', currency: 'BHD' }, OM: { name: 'Oman', currency: 'OMR' },
      JO: { name: 'Jordan', currency: 'JOD' },
      BR: { name: 'Brazil', currency: 'BRL' }, MX: { name: 'Mexico', currency: 'MXN' },
      AR: { name: 'Argentina', currency: 'ARS' }, CL: { name: 'Chile', currency: 'CLP' },
      CO: { name: 'Colombia', currency: 'COP' }, PE: { name: 'Peru', currency: 'PEN' },
      ZA: { name: 'South Africa', currency: 'ZAR' }, EG: { name: 'Egypt', currency: 'EGP' },
      MA: { name: 'Morocco', currency: 'MAD' }, NG: { name: 'Nigeria', currency: 'NGN' },
      KE: { name: 'Kenya', currency: 'KES' }, IN: { name: 'India', currency: 'INR' }
    };

    function flagEmoji(code) {
      return code.toUpperCase().split('')
        .map(c => String.fromCodePoint(127397 + c.charCodeAt(0))).join('');
    }

    async function detect() {
      try {
        const ctrl = new AbortController();
        const t = setTimeout(() => ctrl.abort(), 3000);
        const res = await fetch('https://ipapi.co/json/', { signal: ctrl.signal });
        clearTimeout(t);
        if (!res.ok) return null;
        const data = await res.json();
        return (data.country_code || data.country || '').toUpperCase() || null;
      } catch (e) { return null; }
    }

    function switchCountry(code) {
      const f = document.createElement('form');
      f.method = 'POST';
      f.action = '/localization';
      const fields = {
        '_method': 'PUT',
        'country_code': code,
        'return_to': window.location.pathname + window.location.search
      };
      Object.entries(fields).forEach(([n, v]) => {
        const i = document.createElement('input');
        i.type = 'hidden'; i.name = n; i.value = v;
        f.appendChild(i);
      });
      document.body.appendChild(f);
      f.submit();
    }

    function showBanner(code, country) {
      const el = document.createElement('div');
      el.className = 'geo-banner';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-label', 'Currency suggestion');
      el.innerHTML = `
        <button class="geo-banner-close" aria-label="Dismiss">&times;</button>
        <div class="geo-banner-flag" aria-hidden="true">${flagEmoji(code)}</div>
        <div class="geo-banner-text">Shipping to <strong>${country.name}</strong>? View prices in <strong>${country.currency}</strong>.</div>
        <div class="geo-banner-actions">
          <button class="geo-banner-yes">Switch to ${country.currency}</button>
          <button class="geo-banner-no">Keep USD</button>
        </div>`;
      document.body.appendChild(el);
      requestAnimationFrame(() => el.classList.add('is-visible'));

      const dismiss = () => {
        try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
        el.classList.remove('is-visible');
        setTimeout(() => el.remove(), 450);
      };
      el.querySelector('.geo-banner-yes').addEventListener('click', () => {
        try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
        switchCountry(code);
      });
      el.querySelector('.geo-banner-no').addEventListener('click', dismiss);
      el.querySelector('.geo-banner-close').addEventListener('click', dismiss);
    }

    const SESSION_KEY = 'relix_geo_checked';

    async function init() {
      try { if (localStorage.getItem(STORAGE_KEY)) return; } catch (e) {}
      // At most one detection (and one banner) per browsing session
      try { if (sessionStorage.getItem(SESSION_KEY)) return; } catch (e) {}

      const code = await detect();
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
      if (!code) return;
      // Skip US/CA — primary markets, already on USD/CAD by default
      if (code === 'US' || code === 'CA') return;
      // Already browsing in the detected country's market — nothing to suggest
      if (window.__relixCountry && String(window.__relixCountry).toUpperCase() === code) return;
      const country = COUNTRIES[code];
      if (!country) return;

      // Don't show if URL already has country param matching detected
      const urlCountry = new URLSearchParams(window.location.search).get('country');
      if (urlCountry && urlCountry.toUpperCase() === code) return;

      showBanner(code, country);
    }

    if (document.readyState === 'complete') setTimeout(init, 1500);
    else window.addEventListener('load', () => setTimeout(init, 1500));
  })();
